/**
 * @generated SignedSource<<5e39f6b8c71c37a5310128b03eed07e2>>
 * @relayHash 531b781fde4e7a29fd61d82c22cf29a5
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-admin-accounts/542.0.0-2026-01-13T16:17:31.790Z/getSocialNetworksQuery

import { ConcreteRequest } from 'relay-runtime';
export type getSocialNetworksQuery$variables = Record<PropertyKey, never>;
export type getSocialNetworksQuery$data = {
  readonly viewer: {
    readonly socialNetworks: ReadonlyArray<{
      readonly name: string | null;
      readonly parameters: {
        readonly clientId: string | null;
      } | null;
    } | null> | null;
  };
};
export type getSocialNetworksQuery = {
  response: getSocialNetworksQuery$data;
  variables: getSocialNetworksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "SocialNetworkParameters",
  "kind": "LinkedField",
  "name": "parameters",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clientId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "getSocialNetworksQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SocialNetwork",
            "kind": "LinkedField",
            "name": "socialNetworks",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "getSocialNetworksQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SocialNetwork",
            "kind": "LinkedField",
            "name": "socialNetworks",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-admin-accounts/542.0.0-2026-01-13T16:17:31.790Z/getSocialNetworksQuery",
    "metadata": {},
    "name": "getSocialNetworksQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9c25b76e788503e4a2417072e940c08c";

export default node;
